import React, { useMemo, useState } from "react";
import { Form } from "react-bootstrap";

export default function ProductIdMultiPicker({
  label,
  options = [],
  value = [],
  onChange,
  disabled = false,
  helpText = "",
}) {
  const [filter, setFilter] = useState("");
  const selected = useMemo(() => new Set(value || []), [value]);

  const filteredOptions = useMemo(() => {
    const q = filter.trim().toLowerCase();
    if (!q) return options;
    return options.filter((opt) => opt.label.toLowerCase().includes(q));
  }, [filter, options]);

  const toggle = (productId) => {
    if (disabled) return;
    const next = new Set(selected);
    if (next.has(productId)) next.delete(productId);
    else next.add(productId);
    onChange([...next]);
  };

  return (
    <div className="product-id-multi-picker">
      {label && <Form.Label className="small fw-semibold">{label}</Form.Label>}
      <Form.Control
        size="sm"
        type="search"
        placeholder="Search products…"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        disabled={disabled}
        className="mb-2"
      />
      <div
        className="border rounded p-2"
        style={{ maxHeight: 180, overflowY: "auto", background: "#fafafa" }}
      >
        {filteredOptions.length === 0 ? (
          <p className="text-secondary small mb-0">No products match.</p>
        ) : (
          filteredOptions.map((opt) => (
            <Form.Check
              key={opt.value}
              type="checkbox"
              id={`product-pick-${opt.value}`}
              label={opt.label}
              checked={selected.has(opt.value)}
              onChange={() => toggle(opt.value)}
              disabled={disabled}
              className="small"
            />
          ))
        )}
      </div>
      {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
      {selected.size > 0 && (
        <Form.Text className="text-muted d-block mt-1">{selected.size} selected</Form.Text>
      )}
    </div>
  );
}
